import * as React from "react";
import { Field } from "@progress/kendo-react-form";

import { FormEditor } from "../FormComponents";
import { requiredValidator } from "../validators";

export interface ExamNewCoVetProps {
    examID: string,
    newExam: boolean,
    formHeight: number,
}
const ExamNewCoVet = ({
    examID,
    newExam,
    formHeight
}: ExamNewCoVetProps) => {

    return (
        <div className={"sds-questionnaire"} style={{ marginTop: "4px" }}>
            <fieldset
                style={{}}
                className={"k-form-fieldset"}
            >
                <legend
                    style={{ marginBottom: "-16px" }}
                    className={"k-form-legend"}>
                    CoVet Summary
                </legend>
                <Field
                    style={{ height: ((formHeight - 64) + "px") }}
                    label={""}
                    name={"N394"}
                    component={FormEditor}
                    validator={newExam ? undefined : requiredValidator}
                />
                <p />
            </fieldset>
            {newExam &&
                <div style={{ fontWeight: "bold", marginTop: "64px", textAlign: "center" }}>
                Click the 'Submit' button (bottom-right) to submit exam for processing.
                </div>
            }
        </div>
    );
}

export default ExamNewCoVet;
